import React from 'react';
import {withStyles} from '@material-ui/core';
import {Helmet} from "react-helmet";
import {metaDescriptions, metaImages, metaTitles} from "../website-utils/meta";
import ScrollToTopOnMount from "../website-utils/ScrollToTopOnMount";
import logoBlack from '../assets/images/logo-black.png';
import heroSenso from '../assets/images/senso.jpg';
import {Link} from "react-router-dom";
import config, {API_ROOT} from "../config";
import {fetchBusinessById, fetchJobs} from "../services";
import fetch from 'cross-fetch';
import moment from 'moment';
import {placeParams} from "../utilities";


class ShiftListPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      upcomingShifts: [],
      jobs: [],
      businesses: [],
    };
  }

  componentDidMount() {
    window.analytics.page("Shift List");

    fetch(API_ROOT + '/shifts/upcoming/').then(response => {
      if (response.status === 200) {
        response.json().then(shifts => {
          if (shifts.length > 0) {
            this.setState({
              upcomingShifts: shifts.sort((shiftA, shiftB) => moment(shiftA.start_time) - moment(shiftB.start_time))
            });

            // We need to get all the business information for these shifts
            // Get the unique business IDs
            const uniqueBusinessIDs = [...new Set(shifts.map(shift => shift.business))];
            uniqueBusinessIDs.map(id => {
              fetchBusinessById(id).then(business => {
                this.setState(prevState => ({
                  businesses: prevState.businesses.concat(business)
                }));
              });
            });

            fetchJobs().then(jobs => {
              this.setState({
                jobs: jobs
              });
            });
          }
        });
      } else {
        // Something went wrong. We should error, but for now we'll just 404
        this.props.history.push(config.routes.notFound);
      }
    });
  }

  render() {
    const {classes} = this.props;

    console.log(this.state);
    const shifts = this.state.upcomingShifts;

    const businesses = this.state.businesses.sort((a, b) => {
      if (a.name > b.name) return 1;
      return -1;
    });

    const augmentedBusinesses = businesses.map(business => {
      const jobs = [...new Set(shifts.map(shift => shift.job))];
      const wages = [...new Set(shifts.map(shift => shift.wage))];
      console.log(jobs);
      console.log(wages);

      const businessShifts = shifts.filter(shift => shift.business === business.id);

      // We arrange the shifts into a job-wage pair
      let groupedShifts = [];
      jobs.map(job => {
        wages.map(wage => {
          const filteredShifts = businessShifts.filter(shift => (shift.job === job && shift.wage === wage));
          const jobObjects = this.state.jobs.filter(aJob => aJob.id === job);

          if (filteredShifts.length > 0 && jobObjects.length > 0) {
            groupedShifts = groupedShifts.concat({
              jobName: jobObjects[0].name,
              wage: wage,
              shifts: filteredShifts,
            });
          }
        });
      });

      business.groupedShifts = groupedShifts;

      return business;
    });

    console.log(augmentedBusinesses);

    return (
      <div className={classes.shiftPage}>
        <ScrollToTopOnMount/>
        <Helmet>
          {metaTitles('Shifts on SingleShift')}
          {metaDescriptions('List of shifts on SingleShift right now.')}
          {metaImages(`${window.location.origin}${heroSenso}`)}
        </Helmet>
        <div className={classes.header}>
          <div className='container'>
            <div className="row justify-content-md-center">
              <div className="col-md-8 col-sm-12">
                <Link to={config.routes.pros}>
                  <img className={`logo ${classes.logo}`} src={logoBlack}/>
                </Link>
              </div>
            </div>
          </div>
        </div>

        {augmentedBusinesses.map((business, index) => (
          <div key={index} className={classes.bizSection}>
            <div id='hero'>
              <div className='container'>
                <div className='row justify-content-md-center'>
                  <div className='col-md-8 col-sm-12'>
                    <img src={business.image} className='img-fluid' width='940'/>
                  </div>
                </div>
              </div>
            </div>
            <div className='container'>
              <div className='row justify-content-md-center'>
                <div className='col-md-8 col-sm-12'>
                  <h1 className={classes.shiftName}>{business.name}</h1>
                  {business.neighborhood && (
                    <p>
                      {business.neighborhood} (<a href={business.maps} target={'_blank'}>{business.address}</a>)
                    </p>
                  )}
                  <div className={'text-demphasis'} dangerouslySetInnerHTML={{__html: business.about}}/>
                </div>
              </div>

              {business.groupedShifts.map((group, index) => (
                <div key={index} className='row justify-content-md-center'>
                  <div className='col-md-8 col-sm-12'>
                    <h3 className={classes.shiftLabel}>{group.jobName} (${group.wage})</h3>
                    <ul className='list-unstyled'>
                      {group.shifts.map((shift) => (
                        <li key={shift.id}>
                          <Link className={shift.status === config.status.filled.id ? classes.shiftLinkFilled : ''}
                             to={placeParams(config.routes.shiftPage, {slug: shift.slug})}>
                            {moment(shift.start_time).format('dddd, MMM D')} from {moment(shift.start_time).format('h:mmA')} to {moment(shift.end_time).format('h:mmA')}
                            {shift.status === config.status.filled.id ? ' (Filled)' : ''}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    );
  }
}


export default withStyles((theme) => ({
  logo: {
    marginBottom: '30px',
  },
  header: {
    padding: '20px 0',
  },
  shiftPage: {
    marginBottom: '50px',
    '& p': {
      fontSize: '16px',
      lineHeight: '25px',
      marginBottom: '20px'
    },
  },
  bizSection: {
    marginBottom: '90px',
  },
  shiftLinkFilled: {
    color: '#B4B3B3',
  },
  shiftSection: {
    borderBottom: '1px solid #ccc',
    marginBottom: '30px',
    paddingBottom: '10px',
  },
  shiftName: {
    fontSize: '20px',
    fontWeight: 'bold',
    lineHeight: '35px',
    marginTop: '15px',
    marginBottom: 0,
    [theme.breakpoints.up('md')]: {
      fontSize: '30px',
      lineHeight: '45px',
    },
  },
  shiftLabel: {
    fontSize: '16px',
    lineHeight: '25px',
    fontWeight: 'bold',
    marginBottom: 0,
  },
  shiftBox: {
    border: '1px solid #ccc',
    padding: '15px 10px',
    marginBottom: '20px',
    '& p': {
      marginBottom: '0'
    },
  },
}))(ShiftListPage);



// WEBPACK FOOTER //
// ./src/pages/ShiftListPage.js